import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import SimpleModal from '../../patterns/SimpleModal';
import { colors } from '../../../defaultTheme';
import Button from '../../atoms/Button';
import { Body, H2 } from '../../typography';
export const Modal = styled(SimpleModal) `
  max-width: 500px;
`;
const HeaderContainer = styled.div `
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${colors.grey};
`;
const ModalTitle = styled(H2) `
  font-size: 16px;
`;
export const Content = styled.div `
  padding: 0 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  & > * {
    margin-top: 24px;
  }
`;
export const IconWrapper = styled.div `
  color: ${({ theme }) => theme.button.background};
`;
export const Header = ({ id, title, headerRef }) => {
    return (_jsx(HeaderContainer, Object.assign({ id: id }, { children: _jsx(ModalTitle, Object.assign({ weight: "bold", ref: headerRef }, { children: title })) })));
};
const BarContainer = styled.div `
  background-color: ${colors.lightestGrey};
  display: flex;
  justify-content: flex-start;
  width: 100%;
`;
const Progress = styled.div `
  @keyframes expand {
    0% {
      transform: scaleX(0);
    }
    100% {
      transform: scaleX(1);
    }
  }

  display: inline-block;
  background-color: ${({ theme }) => theme.button.background};
  height: 8px;
  width: 100%;
  animation: expand ${({ durationSeconds }) => durationSeconds}s linear;
  transform-origin: 0%;
`;
export const ActionButton = styled(Button) `
  width: 300px;
  max-width: 100%;
  margin-bottom: 20px;
`;
export const CountdownBar = ({ durationSeconds }) => {
    return (_jsx(BarContainer, { children: _jsx(Progress, { durationSeconds: durationSeconds }) }));
};
export const CountdownTime = ({ action, durationSeconds }) => {
    const [timeLeft, setTimeLeft] = useState(durationSeconds);
    useEffect(() => {
        if (timeLeft) {
            const updateCountdown = () => {
                setTimeLeft(timeLeft - 1);
            };
            const countdownInterval = setInterval(updateCountdown, 1000);
            return () => {
                clearInterval(countdownInterval);
            };
        }
        if (timeLeft <= 0) {
            action();
        }
        // resolves 'consistent return' ts error
        return undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeLeft]);
    return (_jsxs(Body, Object.assign({ isInline: true, weight: "bold" }, { children: [' ', timeLeft] })));
};
